import { render, staticRenderFns } from "./feriados.vue?vue&type=template&id=0c70c8fc"
import script from "./feriados.vue?vue&type=script&lang=js"
export * from "./feriados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports